import * as countries from "i18n-iso-countries";
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const createTerritoryList = () => {
	const allCountriesArray = Object.entries(countries.getNames("en"));
	allCountriesArray.sort((a, b) => {
		if (a[1] < b[1]) {
			return -1;
		}
		if (a[1] > b[1]) {
			return 1;
		}
		return 0;
	});
	return allCountriesArray;
};

export const getTerritoryList = () => {
	const allCountries = createTerritoryList();
	return allCountries.map(country => ({
		key: country[0],
		value: country[0],
		label: country[1],
	}));
};
